function validate_length_max_150(input) {
  return input.length > 150
}

export default validate_length_max_150
